export function decimalToMixedNumber(decimal) {
  const feet = Math.floor(decimal);
  const inches = Math.floor((decimal - feet) * 12);
  let numerator = inches;
  let denominator = 12;

  // If the numerator is zero, return the feet only
  if (numerator === 0) {
    return feet.toString() + "ft";
  }

  // If the feet is zero, return the fraction only
  if (feet === 0) {
    return numerator.toString() + "/" + denominator.toString();
  }

  // Return the mixed number format in feet and inches
  return `${feet.toString() + "'-" + inches.toString() + `"`}`;
}
